export const stock = {
  title: 'Warehouse-in(Storing)',
}
